import {
  searchResultCountState,
  searchResultPagesState,
} from "@/context/states";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import LoadMoreButton from "./LoadMoreButton";
import MusikSuchenResultsContainer from "./MusikSuchenResultsContainer";
import MusikSuchenResultsCount from "./MusikSuchenResultsCount";
import PlaylistListPage from "./PlaylistListPage";

export default function MusikSuchenResultPlaylists({ searchConfig }) {
  const searchResultCount = useRecoilValue(searchResultCountState);
  const [searchResults, setSearchResults] = useRecoilState(
    searchResultPagesState,
  );
  const [pageIndex, setPageIndex] = useState(1);

  useEffect(() => {
    if (pageIndex > 1) {
      const pages = [];
      for (let i = 0; i < pageIndex; i++) {
        pages.push(
          <PlaylistListPage searchConfig={searchConfig} page={i} key={i} />,
        );
      }
      setSearchResults({ ...searchResults, playlists: pages });
    }
  }, [pageIndex]);

  return (
    <MusikSuchenResultsContainer>
      <MusikSuchenResultsCount results={searchResultCount.playlists} />
      <Grid item xs={12}>
        <Grid container sx={{ gap: "0.5rem" }}>
          {searchResults.playlists.map((playlist, index) => (
            <Grid container spacing={3} key={index}>
              {playlist}
            </Grid>
          ))}
        </Grid>
        {searchResultCount % 24 === 0 &&
          searchResults.playlists.length !== 0 && (
            <Grid item xs={12}>
              <LoadMoreButton
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                label="Playlisten"
              />
            </Grid>
          )}
      </Grid>
    </MusikSuchenResultsContainer>
  );
}
